'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// ./~/auth0-lock/~/react-dom/index.js
// module id = 187
// module chunks = 0